/**
 * thousandSeparate  千分位分隔
 * @param  {any} int - 千分位分隔
 */
function thousandSeparate(int:any) {
    if (typeof int !== 'number') {
        return int;
    }
    // const len = int.toString().length;
    // 带小数点直接返回
    const dot = int.toString().split('.')[1];
    const len = int.toString().split('.')[0].length;
    if (dot) {
        return int;
    }
    const threeMul = Math.floor(len / 3);
    const mod = len % 3;
    const num = int.toString();
    if (threeMul === 0) {
        return num;
    }
    let result = '';
    if (mod !== 0) {
        result = num.substring(0, mod);
    }
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < threeMul; i++) {
        result += ((mod === 0 && i === 0) ? '' : ',') + num.substring(mod + i * 3, (mod + (i + 1) * 3));
    }
    return result;
}
/**
 * typeof
 * @param  {any} obj
 */
function typeOf(obj:any) {
    const { toString } = Object.prototype;
    const map:any = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object',
    };
    return map[toString.call(obj)];
}


/**
 *  AddElement 数据添加统一字段
 * @param  {any} data - 原始数据
 * @param  {string} key - key
 * @param  {any} value - value
 */
function AddElement(data:any, key:string, value:any) {
    const t = typeOf(data);
    if (t === 'array') {
        for (let a = 0; a < data.length; a++) {
            data[a][key] = value;
        }
    }
    return data;
}


/**
 * 图表tooltip
 * @param  {any} params
 */
function tooltip_formatter(params:any) {
    const namespan = `<span style="color: #292F3A;font-size: 12px;line-height: 12px;height: 12px;">${params[0].name}</span><br/>`;
    const content:any = [];
    for (let i = 0, len = params.length; i < len; i++) {
        const param = params[i];
        const maker = `<span style="display:inline-block;margin-right:8px;border-radius:2px;width:10px;height:10px;background-color:${param.color};"></span>`;
        const data = `<span style="height: 12px;color: #292F3A;font-size: 12px;font-weight: 500;line-height: 12px;">${param.name}: ${thousandSeparate(param.value)}</span>`;
        content.push(maker + data);
    }
    return `${namespan}<div style="padding-top: 8px;">${content.join('<br/>')}</div>`;
}


/**
 * dataChartFromat
 * @param  {any} data -  处理图表数据格式 给折线图加效果
 */
function dataChartFromat(data:any) {
    const tpl:any = [];
    Object.keys(data).forEach((d:any) => {
        if (d !== 'time') {
            tpl.push(
                {
                    name: d,
                    type: 'line',
                    symbolSize: 6,
                    itemStyle: { borderWidth: 2 },
                    lineStyle: { width: 3 },
                    data: data[d],
                },
            );
        }
    });
    return tpl;
}

/**
 * getBarXdata
 * @param  {any} data - {name:'', value}
 *  获取所有的name
 * 用于特殊Bar表格 X轴不展示时间，展示类别
 */
function getBarXdata(data:any) {
    const name:any = [];
    data.forEach((d:any) => {
        name.push(d.name);
    });
    return name;
}
/**
 * clearObj - 清空obj
 * @param  {Object} data - Object
 */
function clearObj(data:Object) {
    Object.keys(data).forEach((d:any) => {
        data[d] = '';
    });
}


/** deepCopy  深度复制
 * @param  {} obj
 */

function deepCopy(data:any) {
    const t = typeOf(data);
    let o;

    if (t === 'array') {
        o = [];
    } else if (t === 'object') {
        o = {};
    } else {
        return data;
    }

    if (t === 'array') {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < data.length; i++) {
            o.push(deepCopy(data[i]));
        }
    } else if (t === 'object') {
        // eslint-disable-next-line no-restricted-syntax
        for (const i in data) {
            if (data[i]) {
                o[i] = deepCopy(data[i]);
            }
        }
    }
    return o;
}
/**
 * formatSum
 * @param  {} sum
 */
function formatSum(sum:any) {
    if (sum) {
        return sum && sum
            .toString()
            .replace(/(^|\s)\d+/g, (m:any) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
    }
    return '0';
}

export {
    AddElement, thousandSeparate, tooltip_formatter, dataChartFromat, getBarXdata, clearObj, deepCopy, formatSum,
};
